import { useMutation } from '@tanstack/react-query';

import { infoTechApi } from 'api/infoTech';

export function useSendNetSuitePromptMutation({ onError, onSuccess } = {}) {
    return useMutation({
        mutationFn: async (prompt) => {
            const res = await infoTechApi.sendNetSuitePrompt(prompt);
            if (!res.status) {
                throw new Error(res.msg || 'Failed to send prompt');
            }
            return res.data;
        },
        onError,
        onSuccess,
    });
}
